export const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事', count: 128 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '异世界冒险与魔法', count: 96 },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line', description: '热血沸腾的战斗场面', count: 85 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的推理故事', count: 64 },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常', count: 72 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '深度感人的故事剧情', count: 58 },
];

export const hotComics = [
  {
    id: 1,
    slug: 'i-alone-level-up',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '动作',
    rating: 4.9,
    status: '连载中',
    latestChapter: '第 189 话',
    description: '在一个突然出现"门"的世界里，E级猎人成振宇在一次双重副本中濒死，却获得了神秘的"系统"，从此开启了独一无二的升级之路。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20comic%20cover%20illustration%20of%20a%20powerful%20warrior%20in%20dark%20armor%2C%20clean%20minimal%20composition%2C%20dramatic%20lighting%2C%20intense%20expression%2C%20modern%20digital%20illustration%2C%20dark%20atmospheric%20background%2C%20high%20quality%20anime%20style%20art%2C%20elegant%20and%20refined%20artwork&width=600&height=800&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: 2,
    slug: 'goddess-descends',
    title: '女神降临',
    author: '喵喵',
    category: '恋爱',
    rating: 4.8,
    status: '已完结',
    latestChapter: '已完结',
    description: '通过化妆技巧从丑小鸭变身为校园女神，林周京在美貌与真我之间不断挣扎，同时面临两个截然不同的男生的感情抉择。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20romance%20comic%20cover%2C%20elegant%20female%20character%20with%20soft%20makeup%2C%20clean%20minimal%20composition%2C%20warm%20pink%20and%20cream%20tones%2C%20modern%20digital%20illustration%2C%20romantic%20atmosphere%2C%20high%20quality%20art%2C%20delicate%20character%20design&width=600&height=800&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: 3,
    slug: 'sweet-home',
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    category: '悬疑',
    rating: 4.7,
    status: '已完结',
    latestChapter: '已完结',
    description: '在怪物横行的末世公寓中，一个绝望的少年和幸存者们为了生存而战斗。欲望使人变成怪物，而人性能否战胜黑暗？',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20webtoon%20horror%20cover%2C%20apocalyptic%20apartment%20scene%2C%20moody%20atmospheric%20lighting%2C%20suspenseful%20mood%2C%20modern%20digital%20illustration%2C%20dramatic%20shadows%2C%20thriller%20aesthetic%2C%20high%20contrast%2C%20dark%20background%2C%20refined%20artwork&width=600&height=800&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: 4,
    slug: 'god-of-high-school',
    title: '高校之神',
    author: '朴溶济',
    category: '动作',
    rating: 4.6,
    status: '已完结',
    latestChapter: '已完结',
    description: '全国高中生格斗大赛拉开帷幕，各路高手齐聚一堂。陈毛利以独特的路拳道技法踏上夺冠之路，却发现比赛背后隐藏着更大的阴谋。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20webtoon%20action%20cover%2C%20martial%20arts%20fighter%20in%20motion%2C%20energetic%20composition%2C%20clean%20minimal%20style%2C%20vibrant%20warm%20colors%2C%20modern%20digital%20illustration%2C%20action%20pose%2C%20high%20quality%20anime%20style%20art%2C%20refined&width=600&height=800&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: 5,
    slug: 'true-beauty',
    title: '她的私生活',
    author: '金作家',
    category: '恋爱',
    rating: 4.7,
    status: '连载中',
    latestChapter: '第 156 话',
    description: '职场精英成德美私下却是个狂热的偶像追星族，而当她遇到新来的美术馆馆长莱恩后，她的双重生活开始发生改变。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20chic%20Korean%20webtoon%20romance%20cover%2C%20professional%20woman%20character%2C%20modern%20office%20aesthetic%2C%20clean%20minimal%20composition%2C%20soft%20warm%20lighting%2C%20stylish%20illustration%2C%20cream%20background%2C%20high%20quality%20art%2C%20elegant&width=600&height=800&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: 6,
    slug: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    category: '奇幻',
    rating: 4.8,
    status: '连载中',
    latestChapter: '第 578 话',
    description: '少年二十五夜为了追寻唯一的挚友拉赫尔，进入了神秘的巨塔。每登上一层都要通过残酷的试炼，而塔顶据说可以实现任何愿望。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20mystical%20Korean%20webtoon%20fantasy%20cover%2C%20ancient%20tower%20rising%20to%20sky%20with%20young%20hero%2C%20mysterious%20atmosphere%2C%20clean%20minimal%20composition%2C%20warm%20golden%20lighting%2C%20modern%20digital%20illustration%2C%20epic%20scale%2C%20high%20quality%20art&width=600&height=800&seq=comic-cover-06&orientation=portrait',
  },
  {
    id: 7,
    slug: 'lookism',
    title: '外貌至上主义',
    author: '朴泰俊',
    category: '剧情',
    rating: 4.5,
    status: '连载中',
    latestChapter: '第 472 话',
    description: '胖墩墩的朴亨硕因外貌饱受欺凌，转学后竟发现自己有了两具身体——一个帅气完美，一个依然是原来的自己。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20drama%20cover%20showing%20duality%20of%20a%20character%2C%20split%20composition%20with%20contrasting%20sides%2C%20clean%20minimal%20style%2C%20dramatic%20lighting%2C%20modern%20digital%20illustration%2C%20high%20quality%20anime%20art%2C%20emotional%20expression&width=600&height=800&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: 8,
    slug: 'noblesse',
    title: '大贵族',
    author: '孙齐镐 / 李光洙',
    category: '奇幻',
    rating: 4.7,
    status: '已完结',
    latestChapter: '已完结',
    description: '沉睡了820年的贵族莱杰罗在现代社会中醒来，成为一所高中学生，暗中守护着人类世界免受邪恶势力侵害。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20elegant%20Korean%20webtoon%20vampire%20fantasy%20cover%2C%20noble%20aristocratic%20character%20in%20modern%20setting%2C%20dark%20and%20refined%20aesthetic%2C%20clean%20minimal%20composition%2C%20mysterious%20lighting%2C%20modern%20digital%20illustration%2C%20high%20quality%20art%2C%20sophisticated&width=600&height=800&seq=comic-cover-08&orientation=portrait',
  },
];

export const latestUpdates = [
  {
    id: 9,
    slug: 'remarried-empress',
    title: '再婚皇后',
    author: 'Alphatart',
    category: '恋爱',
    time: '2小时前',
    chapter: '第 142 话',
    description: '皇后纳维埃被丈夫背叛，她毅然选择离婚并与邻国国王再婚，开启了一段全新的帝国传奇。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20webtoon%20historical%20romance%20cover%2C%20elegant%20empress%20in%20royal%20dress%2C%20ornate%20palace%20background%2C%20clean%20minimal%20composition%2C%20warm%20golden%20lighting%2C%20modern%20digital%20illustration%2C%20high%20quality%20art%2C%20refined%20romantic%20mood&width=600&height=800&seq=comic-cover-09&orientation=portrait',
  },
  {
    id: 10,
    slug: 'eleceed',
    title: 'Eleceed',
    author: '孙齐镐 / ZHENA',
    category: '动作',
    time: '3小时前',
    chapter: '第 267 话',
    description: '拥有闪电能力的少年池宇镇遇到了神秘的特工凯登，两人结下了奇妙的缘分，共同对抗隐藏在世界中的超能力势力。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20webtoon%20superpower%20action%20cover%2C%20young%20hero%20with%20electric%20powers%2C%20energetic%20composition%2C%20blue%20lightning%20effects%2C%20clean%20minimal%20style%2C%20modern%20digital%20illustration%2C%20high%20quality%20anime%20art%2C%20refined&width=600&height=800&seq=comic-cover-10&orientation=portrait',
  },
  {
    id: 11,
    slug: 'doctors-rebirth',
    title: '医仙重生',
    author: 'Taehyung',
    category: '奇幻',
    time: '5小时前',
    chapter: '第 98 话',
    description: '现代外科医生意外穿越到武侠世界，凭借精湛医术在这个以武为尊的世界闯出一片天地。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20medical%20fantasy%20cover%2C%20doctor%20character%20in%20ancient%20martial%20arts%20setting%2C%20fusion%20of%20modern%20and%20traditional%2C%20clean%20minimal%20composition%2C%20warm%20atmospheric%20lighting%2C%20modern%20digital%20illustration%2C%20high%20quality%20art&width=600&height=800&seq=comic-cover-11&orientation=portrait',
  },
  {
    id: 12,
    slug: 'the-begining-after-the-end',
    title: '终末之后',
    author: 'TurtleMe',
    category: '奇幻',
    time: '6小时前',
    chapter: '第 187 话',
    description: '昔日最强国王转世到魔法世界，保留前世记忆的他重新踏上征途，誓要守护珍视的一切。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20reincarnation%20fantasy%20cover%2C%20powerful%20mage%20character%20in%20magical%20world%2C%20epic%20fantasy%20composition%2C%20clean%20minimal%20style%2C%20magical%20glowing%20effects%2C%20modern%20digital%20illustration%2C%20high%20quality%20art%2C%20refined&width=600&height=800&seq=comic-cover-12&orientation=portrait',
  },
  {
    id: 13,
    slug: 'wind-breaker',
    title: '极速风暴',
    author: '赵容善',
    category: '动作',
    time: '8小时前',
    chapter: '第 412 话',
    description: '天才自行车手赵夏岚加入学校的骑行社团，在极速中寻找自由与梦想。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20sports%20action%20cover%2C%20cyclist%20character%20in%20dynamic%20motion%2C%20speed%20and%20energy%2C%20clean%20minimal%20composition%2C%20warm%20sunset%20lighting%2C%20modern%20digital%20illustration%2C%20high%20quality%20anime%20art%2C%20refined&width=600&height=800&seq=comic-cover-13&orientation=portrait',
  },
  {
    id: 14,
    slug: 'secret-class',
    title: '秘密教学',
    author: 'Gangha',
    category: '喜剧',
    time: '10小时前',
    chapter: '第 203 话',
    description: '平凡大学生在几段意外的关系中，开始了一段令人啼笑皆非的"秘密教学"经历。',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20lighthearted%20Korean%20webtoon%20comedy%20cover%2C%20college%20student%20character%20with%20funny%20expression%2C%20playful%20composition%2C%20clean%20minimal%20style%2C%20bright%20warm%20lighting%2C%20modern%20digital%20illustration%2C%20high%20quality%20anime%20art%2C%20cheerful&width=600&height=800&seq=comic-cover-14&orientation=portrait',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20warm%20smile%2C%20clean%20studio%20lighting%2C%20minimal%20cream%20background%2C%20natural%20and%20friendly%20expression%2C%20editorial%20portrait%20photography%2C%20soft%20shadows%2C%20professional%20yet%20approachable%20look&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '"韩漫网真的太棒了！画质超级清晰，下拉式阅读体验比翻页舒服太多了。我每天通勤都在上面追更新，已经推荐给身边所有喜欢看韩漫的朋友了。"',
  },
  {
    id: 2,
    name: '小美',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20young%20Asian%20woman%20with%20gentle%20expression%2C%20soft%20natural%20lighting%2C%20minimal%20warm%20beige%20background%2C%20editorial%20beauty%20portrait%20photography%2C%20clean%20aesthetic%2C%20subtle%20makeup%2C%20calm%20and%20relaxed%20mood&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '"这里收录的韩漫种类特别全，分类也很清晰。我喜欢看恋爱漫画，一搜就能找到好多高分作品，而且全部免费，简直是宝藏网站！"',
  },
  {
    id: 3,
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20stylish%20young%20Asian%20man%20with%20confident%20look%2C%20modern%20urban%20style%2C%20minimal%20light%20gray%20background%2C%20editorial%20fashion%20portrait%20photography%2C%20clean%20lighting%2C%20natural%20pose%2C%20relaxed%20atmosphere&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '"作为重度漫画爱好者，我试用过很多平台，韩漫网的加载速度是最快的。下拉式全集一次性看完，不用等翻页，这点太重要了。强烈推荐！"',
  },
];